import { render, staticRenderFns } from "./ProblemsReprintsPage.vue?vue&type=template&id=ede6daf4&scoped=true&"
import script from "./ProblemsReprintsPage.vue?vue&type=script&lang=js&"
export * from "./ProblemsReprintsPage.vue?vue&type=script&lang=js&"
import style0 from "./ProblemsReprintsPage.vue?vue&type=style&index=0&id=ede6daf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede6daf4",
  null
  
)

export default component.exports